// test708
(708 && 0);
